export const STORE_LINKS = {
  appStore: 'https://apps.apple.com/cl/app/btalentstar/id1438890847',
  googlePlay: 'https://play.google.com/store/apps/details?id=io.inosoft.bsports&pli=1',
  appGallery: 'https://appgallery.huawei.com/app/C110315073',
} as const;
